import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form, FieldArray } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import FieldInput from "../../../../../../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../../../../../CloudStorage/CloudStorage";
import { getPenalty } from "../../../../../../../../redux/categary/action";
import { approvprojectMilestoneWork } from "../../../../../../../../redux/project/action";
import { Tooltip } from "react-tooltip";
import {
  nomorethenhandread,
  removepresent,
} from "../../../../../../../Common/FewCommonMethods";
import NumberInputBox from "../../../../../../../CustomComponents/AllCustomeInput/NumberInputBox";
import { titlevalidation } from "../../../../../../../Common/commonvalidation";
import { penaltytips } from "../../../../../../../Common/Tooltips/tooltip";

const formdatatomap = [];

const ProjectAddMilestone = ({ proposalmilestones, setMilesModel, index }) => {
  const [inputtype, setInputtype] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState("");
  const penaltylisting = useSelector(
    ({ categary: { penaltylist } }) => penaltylist,
  );
  const dispatch = useDispatch();
  const initialValues = {
    milestones: formData?.milestones || [
      {
        title: "",
        duration: "",
        duration_type: "",
        amount: "",
        penalty_id: "",
        penalty: "",
      },
    ],
  };

  const validationSchema = Yup.object().shape({
    milestones: Yup.array().of(
      Yup.object().shape({
        title: titlevalidation,
        duration: Yup.number()
          .required("This Field is Required")
          .test("not-zero", "Duration should not be 0", (value) => value > 0)
          .typeError("Duration must be a number"),
        duration_type: Yup.string()
          .required("Duration Type is Required")
          .test(
            "not-only-spaces",
            "Duration Type is Required",
            (value) => value.trim() !== "",
          ),
        amount: Yup.number()
          .required("This Field is Required")
          .test("not-zero", "Amount should not be 0", (value) => value > 0)
          .typeError("Amount must be a number"), // Ensures t
        penalty: Yup.string()
          .required("This Field is Required")
          .test(
            "not-only-spaces",
            "This Field is Required",
            (value) => value.trim() !== "",
          ),
      }),
    ),
  });

  const handleSubmit = (values) => {
    setFormData((prevData) => ({
      ...prevData,
      ...values,
    }));
    const data = {
      ...values?.milestones[0],
      proposal_id: proposalmilestones?.id,
    };

    dispatch(approvprojectMilestoneWork(data, setLoading));
    // setMilesModel(state => !state)
  };

  const handleProficiencyChange = (selectedOption, index, setFieldValue) => {
    setFieldValue(`milestones[${index}].penalty_id`, selectedOption.value);
    setFieldValue(
      `milestones[${index}].penalty`,
      removepresent(selectedOption.label),
    );
  };

  const handlePenaltyInputChange = (event, index, setFieldValue) => {
    setFieldValue(
      `milestones[${index}].penalty`,
      removepresent(event.target.value),
    );
    setFieldValue(`milestones[${index}].penalty_id`, 0);
  };

  const handleDeadlinetypeChange = (selectedOption, index, setFieldValue) => {
    setFieldValue(`milestones[${index}].duration_type`, selectedOption.value);
  };

  const togglePenaltyMode = (index) => {
    setInputtype(!inputtype);
  };
  const duretiontypeoptions = [
    { value: 2, label: "Days" },
    { value: 3, label: "Weeks" },
    { value: 4, label: "Months" },
  ];
  useEffect(() => {
    dispatch(getPenalty());
  }, []);

  return (
    <>
      {/* <ModalHeader toggle={() => setMilesModel(state => !state)}>Edit Milestones </ModalHeader> */}
      <button
        onClick={() => setMilesModel((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Edit Milestones</h4>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formik) => (
            <Form>
              {formdatatomap.map((prop, key) => {
                return (
                  <FieldInput
                    title={prop.title}
                    name={prop.name}
                    placeholder={prop.placeholder}
                    key={key}
                  />
                );
              })}
              <FieldArray name="milestones">
                {({ push, remove }) => (
                  <div className="form-group mb-0">
                    <h6>Add Milestones (Optional)</h6>
                    {formik.values.milestones.map((milestone, index) => (
                      <div
                        key={index}
                        className="mile-flex-cont"
                        style={{ columnGap: "10px" }}
                      >
                        <div className="w-100">
                          <div className="form-group">
                            <FieldInput
                              title={`Milestone ${index + 1} Title`}
                              name={`milestones.${index}.title`}
                              placeholder="Enter milestone title"
                            />
                          </div>
                          <div className="mile-flex">
                            <div className="form-group1">
                              <label>Duretion type</label>
                              <ReactSelect
                                options={duretiontypeoptions} // Dynamic options
                                placeholder="Select "
                                value={duretiontypeoptions.find(
                                  (val) =>
                                    val.value ==
                                    formik.values.milestones[index]
                                      .duration_type,
                                )}
                                onChange={(selectedOption) =>
                                  handleDeadlinetypeChange(
                                    selectedOption,
                                    index,
                                    formik.setFieldValue,
                                  )
                                }
                              />
                              <ErrorMessage
                                name={`milestones.${index}.duration_type`}
                                component="div"
                                className="error"
                              />
                            </div>
                            <div className="form-group1">
                              <NumberInputBox
                                title={`Duration in ${formik.values.milestones[index].duration_type == 2 ? "day" : formik.values.milestones[index].duration_type == 3 ? "weeks" : formik.values.milestones[index].duration_type == 4 ? "months" : ""}`}
                                name={`milestones.${index}.duration`}
                                placeholder="Duration"
                                showstar={false}
                              />
                            </div>
                            <div className="form-group1">
                              <NumberInputBox
                                title={`Price in $`}
                                name={`milestones.${index}.amount`}
                                placeholder="Price"
                                showstar={false}
                              />
                            </div>
                            <div className="form-group1">
                              <label>
                                Penalty in %  &nbsp;
                                <img
                                  data-tooltip-id="my-tooltip-1"
                                  src={`${CloudStorage.cloudurl}/Assets/Images/common/info-circle.svg`}
                                  alt=""
                                />

                              </label>
                              {inputtype ? (
                                <ReactSelect
                                  options={
                                    Array.isArray(penaltylisting) &&
                                    penaltylisting?.map((penalty_id) => ({
                                      value: penalty_id.id,
                                      label: penalty_id.title,
                                    }))
                                  } // Dynamic options
                                  placeholder="Select "
                                  value={
                                    Array.isArray(penaltylisting) &&
                                    penaltylisting
                                      .map((penalty_id) => ({
                                        value: penalty_id.id,
                                        label: penalty_id.title,
                                      }))
                                      .find(
                                        (val) =>
                                          val.value === milestone.penalty_id,
                                      )
                                  }
                                  onChange={(selectedOption) =>
                                    handleProficiencyChange(
                                      selectedOption,
                                      index,
                                      formik.setFieldValue,
                                    )
                                  }
                                />
                              ) : (
                                <input
                                  type="text"
                                  value={
                                    formik.values.milestones[index].penalty
                                  }
                                  onChange={(event) =>
                                    handlePenaltyInputChange(
                                      event,
                                      index,
                                      formik.setFieldValue,
                                    )
                                  }
                                  placeholder="Enter penalty"
                                  onKeyDown={nomorethenhandread}
                                />
                              )}

                              <ErrorMessage
                                name={`milestones.${index}.penalty_id`}
                                component="div"
                                className="error"
                              />
                              <button
                                type="button"
                                onClick={() => togglePenaltyMode(index)}
                                className="buttons border-button mt-1"
                              >
                                {inputtype ? "Enter Manually" : "Use Select"}
                              </button>
                            </div>
                          </div>
                        </div>
                        {formik.values.milestones.length > 1 ? (
                          <button type="button" onClick={() => remove(index)}>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                              alt=""
                            />
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    ))}
                    {/* <button type="button" className='add-more-milestone' onClick={() => push({ title: '', duration: '', duration_type: '', amount: '', penalty_id: '', penalty: '' })}>Add more milestones</button> */}
                  </div>
                )}
              </FieldArray>
              <div className="modal-footer  mt-3">
                {/* <button className='btn no' onClick={() => { setModaltitle(state => !state); hitApi() }}>No</button> */}
                <button className="btn" onClick={formik.handleSubmit}>
                  Save
                </button>
              </div>
              {/* <ModalFooter>
                                <Button className="next-button" color="primary"
                                    type="button"
                                    onClick={formik.handleSubmit}>
                                    SAVE
                                </Button>
                            </ModalFooter> */}
            </Form>
          )}
        </Formik>
        <Tooltip
          id="my-tooltip-1"
          place="bottom"
          content={penaltytips}
        />
      </ModalBody>
    </>
  );
};

export default ProjectAddMilestone;
